(function () {
  'use strict';
 
  if (!document.querySelector('.bk-workshop, .bk-selector, .bk-hero')) return;
 
  const cfg = window.RSBreakup || {};
  const html = document.documentElement;
 
  const SWEET_RE  = /sweet|angel|side\s*a/i;
  const SNARKY_RE = /snark|devil|side\s*b/i;
 
  // ===== Variant resolution =================================================
  // FIX (Aug 2026): the vibe toggle used to update only the visual state. The
  // hidden <input name="id"> in the product form was never rewritten, so every
  // add-to-cart submitted whatever Liquid rendered at page load - the FIRST
  // variant, i.e. Sweet. Picking Snarky produced a Sweet order with no error.
  //
  // Three changes fix it:
  //   1. variantMatchesVibe() checks the variant's OPTION VALUES as well as its
  //      title, so it works no matter how the variant titles are worded.
  //   2. variantIdForVibe() falls back to POSITION when a product has exactly
  //      two variants (first = Sweet, second = Snarky), and logs loudly if it
  //      still can't resolve one.
  //   3. writeHiddenVariantId() pushes the resolved ID into the form on every
  //      vibe change, so the form and the visible toggle can never disagree.
  //
  // currentVariantId() no longer falls back to reading the hidden input. A
  // silent fallback is what shipped the wrong box; an alert is better.
 
  function variantMatchesVibe(v, vibe) {
    if (!v) return false;
    const re = vibe === 'snarky' ? SNARKY_RE : SWEET_RE;
    if (re.test(String(v.title || ''))) return true;
    const opts = v.options || [];
    for (let i = 0; i < opts.length; i++) {
      if (re.test(String(opts[i] || ''))) return true;
    }
    return false;
  }
 
  function variantIdForVibe(vibe) {
    const list = (cfg.variants || []);
    if (!list.length) return null;
    for (let i = 0; i < list.length; i++) {
      if (variantMatchesVibe(list[i], vibe)) return list[i].id;
    }
    // Fixed-tone box (Holiday Angst): one variant, no side to pick, so the
    // single variant IS the answer for either vibe. Without this the Send
    // button resolves null and alerts instead of adding to cart.
    if (list.length === 1) return list[0].id;
    // Positional fallback: a two-variant box is always [Sweet, Snarky].
    if (list.length === 2) {
      console.warn('[RSBreakup] vibe "' + vibe + '" matched no variant title or option value; falling back to position.', list);
      return vibe === 'snarky' ? list[1].id : list[0].id;
    }
    console.error('[RSBreakup] could not resolve a variant for vibe "' + vibe + '".', list);
    return null;
  }
 
  function writeHiddenVariantId(id) {
    if (!id) return;
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    const hid = form.querySelector('input[name="id"]');
    if (hid) hid.value = String(id);
  }
 
  function currentVariantId() {
    const vibe = html.getAttribute('data-vibe') || 'sweet';
    const id = variantIdForVibe(vibe);
    if (id) { writeHiddenVariantId(id); return id; }
    return null;
  }
 
  function detectInitialVibe() {
    const params = new URLSearchParams(window.location.search);
    const variantId = params.get('variant');
    if (variantId && cfg.variants) {
      const v = cfg.variants.find(x => String(x.id) === String(variantId));
      if (v && variantMatchesVibe(v, 'snarky')) return 'snarky';
      if (v && variantMatchesVibe(v, 'sweet'))  return 'sweet';
    }
    const form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      const r = form.querySelector('input[type="radio"]:checked');
      if (r) {
        const labelEl = form.querySelector('label[for="' + r.id + '"]');
        const t = (labelEl ? labelEl.textContent : r.value) || '';
        if (SNARKY_RE.test(t)) return 'snarky';
        if (SWEET_RE.test(t))  return 'sweet';
      }
      const sel = form.querySelector('select[name="id"], select[name^="options"]');
      if (sel && sel.selectedOptions[0]) {
        const t = sel.selectedOptions[0].text || '';
        if (SNARKY_RE.test(t)) return 'snarky';
        if (SWEET_RE.test(t))  return 'sweet';
      }
    }
    return 'sweet';
  }
 
  function setVibe(vibe, opts) {
    if (vibe !== 'sweet' && vibe !== 'snarky') return;
    opts = opts || {};
    html.setAttribute('data-vibe', vibe);
    // Keep the real form in lockstep with the visible toggle, always.
    writeHiddenVariantId(variantIdForVibe(vibe));
    document.querySelectorAll('[data-set-vibe]').forEach(el => {
      el.setAttribute('aria-pressed', el.dataset.setVibe === vibe);
    });
    const cap = vibe === 'sweet' ? 'Sweet' : 'Snarky';
    document.querySelectorAll('[data-vibe-word]').forEach(el => { el.textContent = cap; });
    // Inline flip control offers the OTHER side (the one not currently shown).
    const otherVibe = vibe === 'sweet' ? 'snarky' : 'sweet';
    const otherCap  = vibe === 'sweet' ? 'Snarky' : 'Sweet';
    document.querySelectorAll('[data-vibe-flip]').forEach(el => {
      el.dataset.flipTo = otherVibe;
      const w = el.querySelector('[data-vibe-flip-word]');
      if (w) w.textContent = otherCap;
    });
    fillChips(vibe);
    const acc = document.querySelector('[data-workshop-accent]');
    if (acc) acc.textContent = vibe === 'sweet'
      ? (cfg.accent_sweet  || 'Three soft ones.')
      : (cfg.accent_snarky || 'One terrible joke.');
    if (!opts.fromForm) syncVariantSelector(vibe);
    swapHeroImage(vibe);
    renderTotalLine();
  }
 
  function syncVariantSelector(vibe) {
    const form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    const radios = form.querySelectorAll('input[type="radio"]');
    let hit = null;
    radios.forEach(r => {
      const label = form.querySelector('label[for="' + r.id + '"]');
      const text  = (label ? label.textContent : r.value) || '';
      if (vibe === 'sweet'  && SWEET_RE.test(text))  hit = r;
      if (vibe === 'snarky' && SNARKY_RE.test(text)) hit = r;
    });
    if (hit && !hit.checked) {
      hit.checked = true;
      hit.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const sel = form.querySelector('select[name="id"], select[name^="options"]');
    if (sel) {
      for (const opt of sel.options) {
        if (vibe === 'sweet'  && SWEET_RE.test(opt.text))  { sel.value = opt.value; sel.dispatchEvent(new Event('change', { bubbles: true })); return; }
        if (vibe === 'snarky' && SNARKY_RE.test(opt.text)) { sel.value = opt.value; sel.dispatchEvent(new Event('change', { bubbles: true })); return; }
      }
    }
  }
 
  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (productForm) {
    productForm.addEventListener('change', () => {
      const v = detectInitialVibe();
      if (v !== html.getAttribute('data-vibe')) setVibe(v, { fromForm: true });
    });
  }
 
  document.querySelectorAll('[data-set-vibe]').forEach(el => {
    el.addEventListener('click', () => {
      if (el.classList.contains('bk-send-btn')) return;
      var _sv = el.dataset.setVibe;
      setVibe(_sv);
      if (boxCommitted) swapBoxVariant(_sv);
      // The top-column toggle opts out of the nudge-scroll (data-no-scroll) so the
      // page stays put on the Send button right below it.
      if (el.hasAttribute('data-no-scroll')) return;
      // Gentle nudge down so the matching items below come into view -
      // makes the tap feel like it did something (the selection sits just below).
      var reveal = document.querySelector('.bk-items');
      if (reveal) {
        var target = reveal.getBoundingClientRect().top + window.pageYOffset - 90;
        if (window.pageYOffset < target - 20) {
          window.scrollTo({ top: target, behavior: 'smooth' });
        }
      }
    });
  });
 
  // Inline flip in the "Tuned [vibe]" heading - switches the vibe in place,
  // keeps the top toggle + sticky bar in sync (via setVibe), and does NOT scroll.
  document.querySelectorAll('[data-vibe-flip]').forEach(el => {
    el.addEventListener('click', () => {
      const to = el.dataset.flipTo || (html.getAttribute('data-vibe') === 'sweet' ? 'snarky' : 'sweet');
      setVibe(to);
      if (boxCommitted) swapBoxVariant(to);
    });
  });
 
  const EXAMPLES = cfg.examples || {
    tattoo: { sweet: ['Be Well','Stay Kind','Breathe','Soft Power'], snarky: ['Delete Him','His Loss','Move Along','Next'] },
    sound:  { sweet: ["I'm proud of you.","Your feelings are valid.","Take a deep breath.","Tomorrow is new."],
              snarky: ["He's a walking red flag.","Was that supposed to hurt?","Bye bye, problem person.","Plot twist \u2014 you're the catch."] },
    card:   { sweet: ["Saw this and thought of you. Here whenever you need to talk. \u2014 Mom",
                      "Hard week. Soft basket. Love you. \u2014 Sam",
                      "You don't have to be okay yet. Take your time. \u2014 Dani"],
              snarky: ["His texts are not it. You are. \u2014 Jess",
                       "Throw the whole man away. Love, the group chat.",
                       "Plot twist: still the catch. \u2014 Yourself, probably"] }
  };
 
  function fillChips(vibe) {
    ['tattoo','sound','card'].forEach(addon => {
      const wrap = document.querySelector('[data-chips="' + addon + '"]');
      if (!wrap) return;
      wrap.querySelectorAll('.bk-chip').forEach(c => c.remove());
      (EXAMPLES[addon][vibe] || []).forEach(ex => {
        // Tattoo words show as "Capital then lower" (Title Case); sentences stay as written.
        const label = (addon === 'tattoo')
          ? ex.replace(/\S+/g, function (w) { return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); })
          : ex;
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'bk-chip';
        b.textContent = label;
        b.addEventListener('click', () => fillInput(addon, label));
        wrap.appendChild(b);
      });
    });
  }
 
  const INPUT_IDS = { tattoo: 'bkTtInput', sound: 'bkSbInput', card: 'bkCdInput' };
  function fillInput(addon, value) {
    const input = document.getElementById(INPUT_IDS[addon]);
    if (!input) return;
    const v = addon === 'tattoo' ? value.slice(0, 20) : value;
    input.value = v;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
  }
 
  const ttInput = document.getElementById('bkTtInput');
  if (ttInput) {
    const ttMsg   = document.getElementById('bkTtMsg');
    const ttCount = document.getElementById('bkTtCount');
    function ttScale(len){
      if (len <= 8) return 1;
      if (len <= 12) return 0.92;
      if (len <= 16) return 0.82;
      return 0.74;
    }
    function ttRender(v) {
      const display = v.trim()
        ? v.replace(/\S+/g, function (w) { return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); })
        : 'Your Message';
      if (ttMsg) {
        ttMsg.textContent = display;
        ttMsg.style.setProperty('--tt-scale', ttScale(display.length));
        ttMsg.classList.toggle('is-placeholder', !v.trim());
      }
      if (ttCount) {
        ttCount.textContent = v.length;
        if (ttCount.parentElement) ttCount.parentElement.classList.toggle('is-warn', v.length >= 18);
      }
    }
    ttInput.addEventListener('input', () => ttRender(ttInput.value));
    ttRender(ttInput.value);
  }
 
  // ===== Sound-button preview voice ==========================================
  // The browser reads the sentence aloud. Left alone it grabs whatever default
  // voice the visitor has (often a male robot), so we CHOOSE a female English
  // voice and direct the delivery per vibe: Sweet = slower + warmer,
  // Snarky = brisker + flatter. Where the device has more than one usable
  // voice, the two sides get DIFFERENT ones (accent sells it better than pace).
  var SB_SWEET_RANK  = ['samantha','ava','allison','susan','aria','jenny','michelle','zira','google us english','nicky','zoe','victoria'];
  var SB_SNARKY_RANK = ['zoe','nicky','allison','susan','zira','aria','jenny','michelle','google us english','samantha','ava','victoria'];
  // American English only. A foreign accent is not the brand voice - the snarky
  // read has to be a defiant AMERICAN woman, not a novelty accent.
  var SB_US_RE  = /^en[-_]?US/i;
  var SB_NON_US = /\b(karen|moira|tessa|fiona|serena|veena|rishi|daniel|kate|oliver|libby|maisie|natasha|william|catherine|clara|linda|neerja|google uk english|google australian|google indian)\b/i;
  var SB_MALE    = /\b(alex|daniel|fred|tom|aaron|arthur|gordon|rishi|oliver|reed|ralph|albert|junior|guy|david|mark|george|james|ryan|thomas|christopher|eric|male)\b/i;
  var SB_NOVELTY = /\b(bad news|bahh|bells|boing|bubbles|cellos|deranged|good news|jester|organ|superstar|trinoids|whisper|wobble|zarvox|hysterical|pipe|eddy|flo|grandma|grandpa|rocko|sandy|shelley|kathy)\b/i;
  // Delivery dials. Tuned in "Sound Button Voice - Preview.html".
  // Snarky's attitude comes from a LOW, FLAT read, not speed: rates above ~1.05
  // make the engine slur words together (elision).
  var SB_DIAL = { sweet: { rate: 0.82, pitch: 0.96 }, snarky: { rate: 1.00, pitch: 0.94 } };
  var sbVoices = [], sbPick = { sweet: null, snarky: null };
 
  function sbScore(name, rank) {
    var n = String(name || '').toLowerCase();
    for (var i = 0; i < rank.length; i++) { if (n.indexOf(rank[i]) > -1) return i; }
    return 900;
  }
  function sbBest(rank, exclude) {
    var pool = sbVoices.filter(function (v) { return SB_US_RE.test(v.lang); });
    if (!pool.length) pool = sbVoices.filter(function (v) { return /^en/i.test(v.lang) && !SB_NON_US.test(v.name); });
    if (!pool.length) pool = sbVoices.filter(function (v) { return /^en/i.test(v.lang); });
    if (!pool.length) pool = sbVoices.slice();
    var clean = pool.filter(function (v) { return !SB_MALE.test(v.name) && !SB_NOVELTY.test(v.name); });
    if (clean.length) pool = clean;
    if (exclude) {
      var diff = pool.filter(function (v) { return v !== exclude; });
      if (diff.length) pool = diff;
    }
    pool.sort(function (a, b) { return sbScore(a.name, rank) - sbScore(b.name, rank); });
    return pool[0] || null;
  }
  function sbLoadVoices() {
    if (!('speechSynthesis' in window)) return;
    var v = [];
    try { v = window.speechSynthesis.getVoices() || []; } catch (e) { v = []; }
    if (!v.length) return;
    sbVoices = v;
    sbPick.sweet  = sbBest(SB_SWEET_RANK, null);
    sbPick.snarky = sbBest(SB_SNARKY_RANK, sbPick.sweet);
  }
  if ('speechSynthesis' in window) {
    sbLoadVoices();
    window.speechSynthesis.onvoiceschanged = sbLoadVoices;
    setTimeout(sbLoadVoices, 400);
    setTimeout(sbLoadVoices, 1400);
  }
 
  const sbInput = document.getElementById('bkSbInput');
  if (sbInput) {
    const sbCount   = document.getElementById('bkSbCount');
    const sbCaption = document.getElementById('bkSbCaption');
    const sbStage   = document.getElementById('bkSbStage');
    const sbDevice  = document.getElementById('bkSbDevice');
    const sbBars    = document.querySelectorAll('#bkSbWaveform .bk-sb-bar');
    sbInput.addEventListener('input', () => {
      const v = sbInput.value;
      sbCount.textContent = v.length;
      sbCount.parentElement.classList.toggle('is-warn', v.length >= 55);
      sbCaption.textContent = v || '(your sentence, on demand)';
      sbStage.classList.toggle('is-empty', !v.trim());
      const visible = v.trim() ? Math.max(1, Math.ceil((v.length / 60) * sbBars.length)) : 0;
      sbBars.forEach((b, i) => b.classList.toggle('is-active', i < visible));
    });
    let sbTimer = null;
    sbDevice.addEventListener('click', () => {
      if (sbStage.classList.contains('is-empty')) { sbInput.focus(); return; }
      if (sbStage.classList.contains('is-playing')) return;
      sbStage.classList.add('is-playing');
      sbDevice.classList.add('is-playing');
      clearTimeout(sbTimer);
 
      var stop = function () {
        sbStage.classList.remove('is-playing');
        sbDevice.classList.remove('is-playing');
      };
      var spoke = false;
      var txt = sbInput.value.trim();
      var vibe = (html.getAttribute('data-vibe') === 'snarky') ? 'snarky' : 'sweet';
      var dial = SB_DIAL[vibe];
      try {
        if ('speechSynthesis' in window) {
          window.speechSynthesis.cancel();
          if (!sbVoices.length) sbLoadVoices();
          // Engines slur the final words without terminal punctuation, so both
          // reads get a closing beat if the buyer left one off.
          var say = txt;
          if (!/[.!?\u2026]$/.test(say)) say += '.';
          var u = new SpeechSynthesisUtterance(say);
          var voice = sbPick[vibe];
          if (voice) { u.voice = voice; u.lang = voice.lang; }
          u.rate = dial.rate;
          u.pitch = dial.pitch;
          u.volume = 1;
          u.onend = stop;
          u.onerror = stop;
          window.speechSynthesis.speak(u);
          spoke = true;
        }
      } catch (e) { spoke = false; }
 
      // Safety net only - onend normally stops the animation. Scales with the
      // sentence and the pace so a slow Sweet read is not cut off early.
      var est = Math.max(2600, Math.round(txt.length * 72 / (dial.rate || 1)) + 1400);
      sbTimer = setTimeout(stop, spoke ? est : 2400);
    });
  }
 
  const cdInput = document.getElementById('bkCdInput');
  if (cdInput) {
    const cdCount  = document.getElementById('bkCdCount');
    const cdLetter = document.getElementById('bkCdLetter');
    cdInput.addEventListener('input', () => {
      const v = cdInput.value;
      cdCount.textContent = v.length;
      cdCount.parentElement.classList.toggle('is-warn', v.length >= 190);
      cdLetter.textContent = v;
      cdLetter.classList.toggle('is-empty', !v.trim());
    });
  }
 
  const addons = { tattoo: false, sound: false, card: false };
  const BENCH_ID = { tattoo: 'bkBenchTattoo', sound: 'bkBenchSound', card: 'bkBenchCard' };
  const BASE         = (cfg.base_price   != null ? cfg.base_price   : 7495) / 100;
  const ADDON        = (cfg.addon_price  != null ? cfg.addon_price  : 995)  / 100;
  const BUNDLE_PRICE = (cfg.bundle_price != null ? cfg.bundle_price : 1990) / 100;
 
  function setAddonState(key, on) {
    addons[key] = on;
    const bench = document.getElementById(BENCH_ID[key]);
    if (bench) bench.classList.toggle('is-on', on);
    const btn = document.querySelector('[data-addon-toggle="' + key + '"]');
    if (btn) {
      const t = btn.querySelector('.add-text');
      if (t) t.textContent = on ? 'Added \u00b7 remove' : 'Add \u00b7 $' + ADDON.toFixed(2);
    }
    recalcTotal();
    updateCounter();
  }
 
  document.querySelectorAll('[data-addon-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.addonToggle;
      if (!boxCommitted) { flashLockHint(); return; }
      if (addons[key]) removeAddonFromCart(key); else addAddonToCart(key);
    });
  });
 
  function updateCounter() {
    const on = Object.entries(addons).filter(([, v]) => v).map(([k]) => k);
    const counterEl = document.querySelector('.bk-counter');
    if (counterEl) counterEl.style.display = on.length ? '' : 'none';
    const cEl = document.getElementById('bkAddOnCount');
    if (cEl) cEl.textContent = on.length;
    const extra = on.length === 3 ? BUNDLE_PRICE : on.length * ADDON;
    const xEl = document.getElementById('bkAddOnExtra');
    if (xEl) xEl.textContent = '+ $' + extra.toFixed(2);
    document.querySelectorAll('.pc-dot').forEach(d => {
      d.classList.toggle('is-on', addons[d.dataset.dot]);
    });
    const pct = (on.length / 3) * 100;
    const prog = document.getElementById('bkBundleProgress');
    if (prog) prog.style.width = pct + '%';
    const bar    = document.getElementById('bkBundleBar');
    const label  = document.getElementById('bkBundleLabel');
    const status = document.getElementById('bkBundleStatus');
    const btn    = document.getElementById('bkBundleBtn');
    const n = on.length;
    const bundleTxt = '$' + BUNDLE_PRICE.toFixed(2);
    if (bar) {
      bar.setAttribute('data-state', String(n));
      bar.classList.toggle('is-full', n === 3);
    }
    // Slots only ever fill gold. "Free" belongs to the third POSITION, never to
    // a product, so no slot is ever marked.
    document.querySelectorAll('.bk-bundle .b-slot').forEach(s => {
      s.classList.toggle('is-filled', !!addons[s.dataset.slot]);
    });
    if (label) {
      const base = cfg.bundle_label || 'All three together';
      const num = ' <span class="b-num">' + bundleTxt + '</span>';
      label.innerHTML = n === 3
        ? 'All three in' + num
        : n === 2
          ? 'You\u2019re at <span class="b-num">' + bundleTxt + '</span> already'
          : base + num;
    }
    if (status) {
      const parts = n === 0 ? ['Two at $' + ADDON.toFixed(2) + ' \u00b7', 'the third is on us']
        : n === 1 ? ['One more and the third is free']
        : n === 2 ? ['The third one is free']
        : ['Ready when you are'];
      status.innerHTML = parts.map(p => '<span class="s-part">' + p + '</span>').join(' ');
      status.classList.toggle('is-unlocked', n === 3);
    }
    if (btn) {
      if (n === 1 || n === 2) {
        btn.hidden = false;
        btn.textContent = n === 2 ? 'Add the free one' : 'Add the next one';
        btn.classList.toggle('is-ghost', n === 1);
      } else {
        btn.hidden = true;
        btn.classList.remove('is-ghost');
      }
    }
    renderTotalLine();
  }
 
  function recalcTotal() {
    // Add-ons are their own cart lines now, so the box's Send button shows the
    // box price only.
    const fmt = BASE.toFixed(2);
    document.querySelectorAll('[data-send-total]').forEach(el => el.textContent = fmt);
    const sb = document.getElementById('rsSbPrice');
    if (sb) sb.textContent = '$' + fmt;
  }
 
  // The bar's button only OPENS the next incomplete bench and scrolls to it -
  // each add-on needs typed input, so it can never complete one itself.
  function openBench(key) {
    const bench = document.getElementById(BENCH_ID[key]);
    if (!bench) return;
    bench.classList.add('is-open');
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const y = bench.getBoundingClientRect().top + window.pageYOffset - 70;
    window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
    const inputId = INPUT_IDS[key];
    const inp = inputId ? document.getElementById(inputId) : null;
    if (inp) setTimeout(() => { try { inp.focus({ preventScroll: true }); } catch (e) {} }, 420);
  }
 
  const bundleBtn = document.getElementById('bkBundleBtn');
  if (bundleBtn) {
    bundleBtn.addEventListener('click', () => {
      const next = ['tattoo', 'sound', 'card'].find(k => !addons[k]);
      if (next) openBench(next);
    });
  }
 
  // Deep link support: arriving at the product page with #bkBenchCard or
  // ?bench=card (from the cart's keepsake prompt) opens that bench and scrolls
  // to it. Query param is used by the Shopify URL redirect, which strips #.
  (function deepLinkBench(){
    const byHash = { bkBenchTattoo: 'tattoo', bkBenchSound: 'sound', bkBenchCard: 'card' };
    let key = byHash[(window.location.hash || '').replace('#', '')];
    if (!key) {
      const q = (window.location.search || '').match(/[?&]bench=(tattoo|sound|card)\b/i);
      if (q) key = q[1].toLowerCase();
    }
    if (key) setTimeout(function(){
      // Arriving by deep link means they asked for ONE bench, so close the
      // others (bench 01 is open by default) and open only the one they clicked.
      document.querySelectorAll('.bk-bench').forEach(function(b){ b.classList.remove('is-open'); });
      openBench(key);
    }, 300);
  })();
 
  const addonVariants = cfg.addon_variants || {};
  // Normalize each add-on variant ID to bare digits so a stray space, a full
  // gid:// string, or quotes pasted into the Workshop setting can't break it.
  const addonVid = {};
  ['tattoo','sound','card'].forEach(k => {
    const raw = addonVariants[k];
    const digits = raw != null ? String(raw).replace(/[^0-9]/g, '') : '';
    addonVid[k] = digits || null;
  });
  // Startup diagnostic - open the product page console to confirm all three are wired.
  console.log('[RSBreakup] add-on variant IDs wired:', addonVid);
  console.log('[RSBreakup] box variants:', cfg.variants);
  const propKey = cfg.property_key_text || 'Custom message';
 
  function readAddonText(key) {
    const id = INPUT_IDS[key];
    const el = id ? document.getElementById(id) : null;
    return el ? el.value.trim() : '';
  }
 
  // ---- Direct add-to-cart for the personalization add-ons ----------------------
  // Each "Add / $9.95" button now puts its add-on straight into the cart (and
  // "Remove" takes it out) so there is never a hidden second step. All requests
  // use XMLHttpRequest, NOT fetch(): a third-party app wraps window.fetch and
  // breaks POSTs to /cart/add.js (ERR_NAME_NOT_RESOLVED). XHR bypasses that.
  function cartRoot() { return ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, ''); }
  function cartPost(path, payload) {
    return new Promise((resolve, reject) => {
      const x = new XMLHttpRequest();
      x.open('POST', cartRoot() + path, true);
      x.setRequestHeader('Content-Type', 'application/json');
      x.setRequestHeader('Accept', 'application/json');
      x.onload = () => {
        if (x.status >= 200 && x.status < 300) { try { resolve(JSON.parse(x.responseText)); } catch (e) { resolve({}); } }
        else { let m = ''; try { m = (JSON.parse(x.responseText) || {}).description || ''; } catch (e) {} reject(new Error(path + ' (' + x.status + ') ' + m)); }
      };
      x.onerror = () => reject(new Error(path + ' network error'));
      x.send(JSON.stringify(payload));
    });
  }
  function cartGet() {
    return new Promise((resolve) => {
      const x = new XMLHttpRequest();
      x.open('GET', cartRoot() + '/cart.js', true);
      x.setRequestHeader('Accept', 'application/json');
      x.onload = () => { try { resolve(JSON.parse(x.responseText)); } catch (e) { resolve({ items: [] }); } };
      x.onerror = () => resolve({ items: [] });
      x.send();
    });
  }
  // FIX (Sep 2026): header-actions.js and cart-icon.js both listen for
  // 'cart:update' and read the payload off event.detail - they were never
  // getting one. commitBox() used to dispatch a bare CustomEvent with no
  // detail at all, which threw "Cannot read properties of null/undefined
  // (reading 'resource')" in header-actions.js and (reading 'data') in
  // cart-icon.js on every single successful add - intermittently visible to
  // the shopper depending on exactly where in commitBox()'s try block the
  // throw landed. refreshCartCount() now fetches the live cart and dispatches
  // 'cart:update' with BOTH shapes those two listeners expect:
  //   detail.resource        - the raw /cart.js response (header-actions.js
  //                             reads resource.item_count)
  //   detail.data.itemCount  - same count, camelCase (cart-icon.js)
  //   detail.data.source     - deliberately NOT 'product-form-component', so
  //                             cart-icon.js SETS the bubble to this absolute
  //                             count instead of incrementing it - correct,
  //                             since we just fetched the true cart state.
  // Returns the promise so callers (commitBox) can await the real cart data
  // before moving on, instead of firing events with nothing behind them.
  function refreshCartCount() {
    return cartGet().then(c => {
      const n = c && typeof c.item_count === 'number' ? c.item_count : null;
      if (n != null) {
        document.querySelectorAll('.cart-count-bubble, [data-cart-count], .cart-count, #cart-icon-bubble').forEach(el => {
          const span = el.querySelector('span') || el; span.textContent = n;
        });
      }
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:update', {
        detail: {
          resource: c,
          data: { itemCount: n != null ? n : 0, source: 'rs-breakup' }
        }
      }));
      return c;
    });
  }
  function validateAddon(key) {
    if (key === 'tattoo') { const el = document.getElementById('bkTtInput'); if (!el || !el.value.trim()) { alert('The tattoo needs its words first. Add what they\u2019ll wear, then Add.'); if (el) { el.focus(); el.scrollIntoView({ block: 'center' }); } return false; } }
    if (key === 'sound')  { const el = document.getElementById('bkSbInput'); if (!el || !el.value.trim()) { alert('The sound button needs something to say. Add a line, then Add.'); if (el) { el.focus(); el.scrollIntoView({ block: 'center' }); } return false; } }
    if (key === 'card')   { const nm = document.getElementById('bkCdName'), ms = document.getElementById('bkCdMsg');
      if (!nm || !nm.value.trim()) { alert('Who\u2019s the keepsake card for? Add their name first.'); if (nm) { nm.focus(); nm.scrollIntoView({ block: 'center' }); } return false; }
      if (!ms || !ms.value.trim()) { alert('We don\u2019t send blank cards. Add a short message for the inside.'); if (ms) { ms.focus(); ms.scrollIntoView({ block: 'center' }); } return false; } }
    return true;
  }
  function buildAddonItem(key) {
    const vid = addonVid[key]; if (!vid) return null;
    let text = readAddonText(key);
    if (key === 'tattoo' && text) { text = text.replace(/\S+/g, function (w) { return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); }); }
    const props = text ? { [propKey]: text } : {};
    // The sound button hardware is identical across vibes - only the recorded
    // message changes - but the buyer sees all three add-ons side by side in the
    // cart, so all three carry the Vibe line. Consistency on the page, not a
    // packing instruction.
    if (key === 'tattoo' || key === 'sound') { props['Vibe'] = (html.getAttribute('data-vibe') === 'snarky') ? 'Snarky' : 'Sweet'; }
    if (key === 'card') {
      const nameEl = document.getElementById('bkCdName'), fromEl = document.getElementById('bkCdFrom'), msgEl = document.getElementById('bkCdMsg');
      const nm = nameEl ? nameEl.value.trim() : '', fr = fromEl ? fromEl.value.trim() : '', ms = msgEl ? msgEl.value.trim() : '';
      if (nm) props['Their name'] = nm;
      if (fr) props['From'] = fr;
      if (ms) props['Message'] = ms;
      props['Vibe'] = (html.getAttribute('data-vibe') === 'snarky') ? 'Snarky' : 'Sweet';
    }
    return { id: Number(vid), quantity: 1, properties: props };
  }
  const addonBusy = { tattoo: false, sound: false, card: false };
  function setAddonBtnBusy(key, busy) {
    const btn = document.querySelector('[data-addon-toggle="' + key + '"]');
    if (btn) { btn.disabled = busy; btn.classList.toggle('is-busy', busy); }
  }
  function addAddonToCart(key) {
    if (addonBusy[key]) return Promise.resolve(false);
    if (!addonVid[key]) { alert('This add-on isn\u2019t available right now. (We\u2019re on it.)'); return Promise.resolve(false); }
    if (!validateAddon(key)) return Promise.resolve(false);
    const item = buildAddonItem(key); if (!item) return Promise.resolve(false);
    addonBusy[key] = true; setAddonBtnBusy(key, true);
    return cartPost('/cart/add.js', { items: [item] })
      .then(() => { setAddonState(key, true); refreshCartCount(); return true; })
      .catch(err => { console.error('[RSBreakup] add-on add failed', key, err); alert('Sorry \u2014 couldn\u2019t add that just now. Try again?'); return false; })
      .then(r => { addonBusy[key] = false; setAddonBtnBusy(key, false); return r; });
  }
  function removeAddonFromCart(key) {
    if (addonBusy[key]) return Promise.resolve(false);
    const vid = addonVid[key];
    addonBusy[key] = true; setAddonBtnBusy(key, true);
    return cartPost('/cart/change.js', { id: String(vid), quantity: 0 })
      .then(() => { setAddonState(key, false); refreshCartCount(); return true; })
      .catch(err => { console.error('[RSBreakup] add-on remove failed', key, err); setAddonState(key, false); return false; })
      .then(r => { addonBusy[key] = false; setAddonBtnBusy(key, false); return r; });
  }
  function syncAddonsFromCart() {
    cartGet().then(c => {
      const ids = (c.items || []).map(it => String(it.variant_id || it.id));
      ['tattoo','sound','card'].forEach(k => { const vid = addonVid[k]; if (vid && ids.indexOf(String(vid)) >= 0) setAddonState(k, true); });
    });
  }
 
  // ===== Build-then-send flow ===============================================
  // Nothing personalizes until a box is in the cart. The first Send press adds
  // the box, locks the vibe, and reveals/unlocks the add-ons (no redirect).
  // After that, every Send button becomes "Go to cart".
  var boxCommitted = false, committedVibe = null;
 
  function productVariantIds() {
    var ids = [];
    if (cfg.variants && cfg.variants.length) cfg.variants.forEach(function (v) { ids.push(String(v.id)); });
    var cur = currentVariantId(); if (cur) ids.push(String(cur));
    return ids;
  }
 
  function injectFlowStyles() {
    if (document.getElementById('rsFlowStyles')) return;
    var css = ''
      + '.bk-toggle.rs-pulse{box-shadow:0 0 0 4px rgba(41,63,139,.35);border-radius:999px;transition:box-shadow .3s ease;}'
      + '.rs-pick-modal{position:fixed;inset:0;z-index:9500;display:none;align-items:center;justify-content:center;background:rgba(26,16,8,.45);padding:20px;}'
      + '.rs-pick-modal.rs-open{display:flex;}'
      + '.rs-pick-card{background:#FAF7F2;border-radius:18px;box-shadow:0 24px 60px rgba(26,16,8,.3);max-width:400px;width:100%;padding:30px 26px 24px;text-align:center;position:relative;font-family:"Nunito",system-ui,sans-serif;}'
      + '.rs-pick-card h3{font-family:"Instrument Serif",Georgia,serif;font-weight:400;font-size:27px;margin:0 0 8px;color:#1A1008;}'
      + '.rs-pick-card p{margin:0 0 20px;font-size:14.5px;line-height:1.5;color:#5C4F40;}'
      + '.rs-pick-go{border:0;border-radius:99px;background:#1A1008;color:#fff;font-weight:800;font-size:15px;padding:14px 24px;cursor:pointer;font-family:inherit;}'
      + '.rs-pick-x{position:absolute;top:10px;right:14px;border:0;background:none;font-size:22px;color:#8B7C6A;cursor:pointer;line-height:1;}'
      + '.rs-total-line{font-size:13px;font-weight:700;letter-spacing:.02em;color:#5C4F40;margin:0 0 14px;text-align:center;}'
      + '.bk-send-btn.rs-vibe-btn,button.sb-cta.rs-vibe-btn{background:var(--bk-vibe) !important;border-color:var(--bk-vibe) !important;color:#fff !important;}';
    var st = document.createElement('style'); st.id = 'rsFlowStyles'; st.textContent = css; document.head.appendChild(st);
  }
 
  var pickModal = null;
  function ensureBanner() {
    if (pickModal) return pickModal;
    injectFlowStyles();
    pickModal = document.createElement('div');
    pickModal.className = 'rs-pick-modal';
    pickModal.innerHTML = '<div class="rs-pick-card">'
      + '<button class="rs-pick-x" type="button" aria-label="Close">\u00d7</button>'
      + '<h3>Choose Sweet or Snarky first</h3>'
      + '<p>Pick your box up top and add it, then you can personalize it here.</p>'
      + '<button class="rs-pick-go" type="button">Take me there \u2192</button>'
      + '</div>';
    document.body.appendChild(pickModal);
    function close() { pickModal.classList.remove('rs-open'); }
    pickModal.addEventListener('click', function (e) { if (e.target === pickModal) close(); });
    pickModal.querySelector('.rs-pick-x').addEventListener('click', close);
    pickModal.querySelector('.rs-pick-go').addEventListener('click', function () {
      close();
      var tog = document.querySelector('.bk-toggle') || document.querySelector('[data-set-vibe]');
      var target = tog || document.querySelector('.bk-send');
      if (target) {
        window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - 120, behavior: 'smooth' });
        if (tog) { tog.classList.add('rs-pulse'); setTimeout(function () { tog.classList.remove('rs-pulse'); }, 1300); }
      }
    });
    return pickModal;
  }
 
  function flashLockHint() {
    var m = ensureBanner(); if (m) m.classList.add('rs-open');
  }
 
  function flashVibeLock() {
    var note = document.querySelector('.rs-lock-note');
    if (note) { note.style.color = '#c8202c'; setTimeout(function () { note.style.color = ''; }, 900); }
  }
 
  function setAddonsLocked(locked) {
    if (!locked && pickModal) pickModal.classList.remove('rs-open');
  }
 
  function lockVibe() {
    document.querySelectorAll('.bk-toggle').forEach(function (t) { t.classList.add('rs-locked'); });
    var tog = document.querySelector('.bk-toggle');
    if (tog && !document.querySelector('.rs-lock-note')) {
      var note = document.createElement('p');
      note.className = 'rs-lock-note';
      note.textContent = 'To switch vibe, remove the box from your cart and start over.';
      (tog.parentNode || tog).appendChild(note);
    }
  }
 
  // TOP buttons (hero + sticky) add the box and scroll to personalization.
  // BOTTOM button (in the "Send it." section) navigates to the cart.
  // Both always wear the active vibe colour (matches the toggle exactly).
  // Button labels depend on whether the box is already in the cart.
  // BEFORE commit: top + sticky read "Add it - Personalize" and add the box.
  // AFTER commit:  they read "Review and send" and go to the cart. Without this
  // the sticky bar kept saying "Personalize" and just scrolled to the workshop,
  // leaving a finished buyer with no way forward.
  function setFixedButtons() {
    injectFlowStyles();
    document.querySelectorAll('.bk-send-btn').forEach(function (b) {
      b.classList.add('rs-vibe-btn');
      if (b.closest('.bk-send')) b.innerHTML = '<span>Review and send</span> <span class="arrow">\u2192</span>';
      else if (boxCommitted) b.innerHTML = '<span>Review and send</span> <span class="arrow">\u2192</span>';
      else b.innerHTML = '<span>Add it \u00b7 Personalize \u2193</span>';
    });
    var sb = document.getElementById('rsSbCta');
    if (sb) {
      sb.classList.add('rs-vibe-btn');
      sb.innerHTML = boxCommitted ? 'Review and send \u2192' : 'Add it \u00b7 Personalize \u2193';
    }
  }
 
  function scrollToWorkshop() {
    var ws = document.querySelector('.bk-workshop');
    if (ws) window.scrollTo({ top: ws.getBoundingClientRect().top + window.pageYOffset - 60, behavior: 'smooth' });
  }
 
  function topAction() {
    if (boxCommitted) { goToCart(); return; }
    commitBox(html.getAttribute('data-vibe') || 'sweet');
  }
 
  function bottomAction() {
    if (boxCommitted) { goToCart(); return; }
    commitBox(html.getAttribute('data-vibe') || 'sweet', { toCart: true });
  }
 
  function swapHeroImage(vibe) {
    // New markup (rs-breakup-hero.liquid, Aug 2026) renders BOTH hero photos and
    // shows one via CSS on html[data-vibe] - instant, no flash, both preloaded.
    // When that markup is present there is nothing to swap here.
    if (document.querySelector('.bk-hero-img [data-vibe-img]')) return;
    // Legacy single-<img> fallback: swap the src to the variant's featured image.
    var id = variantIdForVibe(vibe);
    var v = (cfg.variants || []).find(function (x) { return String(x.id) === String(id); });
    var img = document.querySelector('.bk-hero-img img');
    if (v && v.featured_image && img && img.src !== v.featured_image) img.src = v.featured_image;
  }
 
  // After the box is committed, switching vibe swaps the box line in the cart
  // (add the new variant, then zero out the old) so the cart always matches the
  // shown vibe - quantity stays 1, no manual removal needed.
  var boxSwapBusy = false;
  function swapBoxVariant(vibe) {
    if (!boxCommitted || boxSwapBusy) return;
    var newId = variantIdForVibe(vibe);
    var oldId = committedVibe ? variantIdForVibe(committedVibe) : null;
    if (!newId || String(newId) === String(oldId)) { committedVibe = vibe; return; }
    boxSwapBusy = true; committedVibe = vibe;
    cartPost('/cart/add.js', { items: [{ id: Number(newId), quantity: 1 }] })
      .then(function () { return oldId ? cartPost('/cart/change.js', { id: String(oldId), quantity: 0 }) : null; })
      .then(function () { refreshCartCount(); })
      .catch(function (e) { console.error('[RSBreakup] box swap failed', e); })
      .then(function () { boxSwapBusy = false; });
  }
 
  function ensureTotalLine() {
    var host = document.querySelector('.bk-send .bk-send-buttons');
    if (!host) return null;
    var el = document.getElementById('rsTotalLine');
    if (!el) { el = document.createElement('p'); el.id = 'rsTotalLine'; el.className = 'rs-total-line'; host.parentNode.insertBefore(el, host); }
    return el;
  }
 
  function renderTotalLine() {
    var el = ensureTotalLine(); if (!el) return;
    el.style.display = '';
    var vibeWord = (html.getAttribute('data-vibe') === 'snarky') ? 'Snarky' : 'Sweet';
    var count = Object.keys(addons).filter(function (k) { return addons[k]; }).length;
    var extra = count === 3 ? BUNDLE_PRICE : count * ADDON;
    if (extra > 0) {
      var total = BASE + extra;
      el.textContent = vibeWord + ' Box $' + BASE.toFixed(2) + '  \u00b7  Add-ons $' + extra.toFixed(2) + '  \u00b7  Total $' + total.toFixed(2);
    } else {
      el.textContent = vibeWord + ' Box $' + BASE.toFixed(2);
    }
  }

  // ===== "Need it by a date?" mini-popover ===================================
  // Added Aug 2026 alongside the delivery-certainty copy on the product page.
  // We don't have the Liquid markup for the "Out the door in 24 hrs..." line,
  // so this doesn't attach to it directly - instead it's injected right after
  // the Send button, reusing the SAME visual language as the "no pressure"
  // nudge below (cream card, Caveat handwritten accent, Nunito body) so it
  // reads as one established system rather than a bolted-on element.
  // Text-only reassurance - no scheduling logic, just a clear promise.
  var dateHelperOpen = false;
  function ensureDateHelper() {
    var section = document.querySelector('.bk-send');
    if (!section || document.getElementById('rsDateHelper')) return;
    // Anchor on the rendered rs-trust-line ("Out the door in 24 hrs...") so this
    // lands AFTER it, not wedged between the button and the trust line. Falls
    // back to the button row if the trust line markup ever changes.
    var anchor = section.querySelector('.rs-trust-line') || section.querySelector('.bk-send-buttons');
    if (!anchor) return;
    if (!document.getElementById('rsDateHelperStyles')) {
      var css = ''
        + '.rs-date-wrap{text-align:center;}'
        + '.rs-date-trigger{display:inline-block;margin-top:10px;font-size:13px;font-weight:700;color:#5C4F40;text-decoration:underline;text-underline-offset:3px;background:none;border:0;cursor:pointer;font-family:"Nunito",system-ui,sans-serif;padding:2px 0;}'
        + '.rs-date-trigger:hover{color:#1A1008;}'
        + '.rs-date-pop{display:none;margin:12px auto 0;max-width:360px;background:#F4EFE6;border:1px solid #E3D9C8;border-radius:14px;padding:16px 18px;text-align:left;font-family:"Nunito",system-ui,sans-serif;}'
        + '.rs-date-pop.rs-open{display:block;}'
        + '.rs-date-pop .rs-dp-hand{font-family:"Caveat",cursive;font-weight:700;color:#C19858;font-size:22px;line-height:1;margin:0 0 6px;}'
        + '.rs-date-pop p{margin:0;font-size:13.5px;line-height:1.5;color:#5C4F40;}';
      var st = document.createElement('style'); st.id = 'rsDateHelperStyles'; st.textContent = css; document.head.appendChild(st);
    }
    var wrap = document.createElement('div');
    wrap.className = 'rs-date-wrap';
    wrap.innerHTML = '<button type="button" class="rs-date-trigger" id="rsDateTrigger">Need it by a date?</button>'
      + '<div class="rs-date-pop" id="rsDateHelper">'
      + '<div class="rs-dp-hand">We\u2019ll tell you straight.</div>'
      + '<p>Message us before you order and we\u2019ll let you know honestly whether we can make your date \u2014 no guessing.</p>'
      + '</div>';
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    var trigger = document.getElementById('rsDateTrigger');
    var pop = document.getElementById('rsDateHelper');
    trigger.addEventListener('click', function () {
      dateHelperOpen = !dateHelperOpen;
      pop.classList.toggle('rs-open', dateHelperOpen);
    });
  }
 
  function onBoxCommitted(vibe, opts) {
    opts = opts || {};
    boxCommitted = true; committedVibe = vibe || html.getAttribute('data-vibe') || 'sweet';
    injectFlowStyles();
    setAddonsLocked(false);
    setFixedButtons();
    if (opts.scroll !== false) {
      var ws = document.querySelector('.bk-workshop');
      if (ws) window.scrollTo({ top: ws.getBoundingClientRect().top + window.pageYOffset - 60, behavior: 'smooth' });
    }
  }
 
  function goToCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    window.location.href = (cartRoot() || '') + '/cart';
  }
 
  function initBoxCommitFlow() {
    injectFlowStyles();
    ensureBanner();
    setAddonsLocked(true);
    var mine = productVariantIds();
    cartGet().then(function (c) {
      var items = (c.items || []);
      var hit = null;
      for (var i = 0; i < items.length; i++) {
        if (mine.indexOf(String(items[i].variant_id || items[i].id)) >= 0) { hit = items[i]; break; }
      }
      if (hit) {
        var t = hit.variant_title || (hit.variant && hit.variant.title) || '';
        var v = SNARKY_RE.test(t) ? 'snarky' : 'sweet';
        setVibe(v, { fromForm: true });
        onBoxCommitted(v, { scroll: false });
      }
    });
  }
 
  async function commitBox(vibe, opts) {
    opts = opts || {};
    setVibe(vibe);
    const variantId = currentVariantId();
    // Loud failure. The old code fell back to the hidden input here, which held
    // the FIRST variant - that is how a Snarky pick became a Sweet order.
    if (!variantId) {
      console.error('[RSBreakup] no variant id for vibe:', vibe, cfg.variants);
      alert('Sorry \u2014 we couldn\u2019t lock in that vibe. Please refresh and try again.');
      return;
    }
 
    // Add-ons are added the moment their own "Add" button is tapped, so the box's
    // Send button only needs to add the box itself.
    const items = [{ id: Number(variantId), quantity: 1 }];
 
    document.querySelectorAll('.bk-send-btn').forEach(b => b.disabled = true);
 
    try {
      // NOTE: we use XMLHttpRequest, not fetch(). A third-party app on the store
      // wraps window.fetch and breaks POSTs to /cart/add.js (ERR_NAME_NOT_RESOLVED),
      // which silently killed every add-on add. XHR bypasses that wrapper.
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const url = root.replace(/\/$/, '') + '/cart/add.js';
      await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 300) return resolve();
          let msg = '';
          try { msg = (JSON.parse(xhr.responseText) || {}).description || ''; } catch (e) {}
          reject(new Error('Cart add failed (' + xhr.status + ') ' + msg));
        };
        xhr.onerror = () => reject(new Error('Cart add network error'));
        xhr.send(JSON.stringify({ items }));
      });
      // Box is in the cart. Instead of leaving the page, reveal + unlock the
      // personalization block and lock the vibe (prevents Sweet/Snarky mismatch).
      // FIX (Sep 2026): this used to fire two bare CustomEvents here with no
      // detail payload - see the note above refreshCartCount() for the full
      // story. Routing through refreshCartCount() (a) supplies the payload
      // header-actions.js and cart-icon.js actually need, and (b) waits for
      // the real cart state instead of assuming the add-to-cart response.
      await refreshCartCount();
      onBoxCommitted(vibe, { scroll: !opts.toCart });
      if (opts.toCart) goToCart();
    } catch (err) {
      console.error('[RSBreakup] send failed', err);
      alert('Sorry \u2014 something went wrong adding to cart. Try again?');
    } finally {
      document.querySelectorAll('.bk-send-btn').forEach(b => b.disabled = false);
    }
  }
 
  document.querySelectorAll('.bk-send-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.closest('.bk-send')) bottomAction(); else topAction();
    });
  });
 
  const sbCta = document.getElementById('rsSbCta');
  if (sbCta) {
    sbCta.addEventListener('click', e => {
      e.preventDefault();
      topAction();
    });
  }
 
  setVibe(detectInitialVibe(), { fromForm: true });
  fillChips(html.getAttribute('data-vibe'));
  updateCounter();
  recalcTotal();
  syncAddonsFromCart();
  setFixedButtons();
  initBoxCommitFlow();
  ensureDateHelper();
 
  // ---- Gentle "still here when you're ready" nudge ----
  // Fires once per visit after the shopper has fiddled with the personalization
  // a bunch of times without adding anything. Never fires once they hit Send.
  (function initNudge(){
    var station = document.getElementById('bkTtInput') || document.getElementById('bkCdName') || document.querySelector('.bk-send-btn');
    if (!station) return;
    try { if (sessionStorage.getItem('rsNudgeSeen') === '1') return; } catch (e) {}
 
    var THRESHOLD = 8, fiddles = 0, done = false, counted = {};
 
    var css = '.rsn-nudge{position:fixed;left:50%;bottom:22px;transform:translate(-50%,150%);width:min(440px,calc(100vw - 32px));background:#F4EFE6;border:1px solid #E3D9C8;border-radius:18px;box-shadow:0 18px 50px rgba(26,16,8,.22);padding:22px 22px 20px;z-index:9000;opacity:0;pointer-events:none;transition:transform .5s cubic-bezier(.2,.8,.2,1),opacity .4s ease;font-family:"Nunito",system-ui,sans-serif;}'
      + '.rsn-nudge.rsn-show{transform:translate(-50%,0);opacity:1;pointer-events:auto;}'
      + '.rsn-close{position:absolute;top:12px;right:14px;border:0;background:none;font-size:20px;color:#8B7C6A;cursor:pointer;line-height:1;}'
      + '.rsn-eyebrow{font-size:11px;font-weight:800;letter-spacing:.16em;text-transform:uppercase;color:#8B7C6A;}'
      + '.rsn-hand{font-family:"Caveat",cursive;font-weight:700;color:#C19858;font-size:30px;line-height:1;margin:4px 0 8px;}'
      + '.rsn-body{margin:0 0 16px;font-size:14.5px;line-height:1.5;color:#5C4F40;}'
      + '.rsn-acts{display:flex;gap:10px;align-items:center;}'
      + '.rsn-go{border:0;border-radius:99px;background:#1A1008;color:#fff;font-weight:800;font-size:14px;padding:12px 18px;cursor:pointer;}'
      + '.rsn-later{border:0;background:none;color:#8B7C6A;font-size:13px;font-weight:700;cursor:pointer;text-decoration:underline;text-underline-offset:3px;}';
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
 
    var nudge = document.createElement('div');
    nudge.className = 'rsn-nudge';
    nudge.setAttribute('role', 'dialog');
    nudge.setAttribute('aria-label', 'A gentle note');
    nudge.innerHTML = '<button class="rsn-close" type="button" aria-label="Close">\u00d7</button>'
      + '<span class="rsn-eyebrow">No pressure</span>'
      + '<div class="rsn-hand">Take your time.</div>'
      + '<p class="rsn-body">You\u2019ve clearly got someone in mind. Pick a side when you\u2019re ready, and we\u2019ll hand-pack it and get it out the door within 24 hours.</p>'
      + '<div class="rsn-acts"><button class="rsn-go" type="button">Take me to Send \u2192</button><button class="rsn-later" type="button">I\u2019m still looking</button></div>';
    document.body.appendChild(nudge);
 
    function seen(){ try { sessionStorage.setItem('rsNudgeSeen', '1'); } catch (e) {} }
    function show(){ if (done) return; done = true; seen(); nudge.classList.add('rsn-show'); }
    function hide(){ nudge.classList.remove('rsn-show'); }
    function convert(){ done = true; seen(); hide(); }
    // A "fiddle" = one deliberate interaction: a vibe flip, an add-on toggle, or a
    // burst of typing in a field. After THRESHOLD of them with nothing added, nudge.
    function bump(){ if (done) return; fiddles++; if (fiddles >= THRESHOLD) show(); }
 
    document.addEventListener('click', function (e) {
      if (done) return;
      if (e.target.closest('.bk-send-btn, #rsSbCta')) { convert(); return; }
      if (e.target.closest('[data-set-vibe]:not(.bk-send-btn), [data-vibe-flip], [data-addon-toggle]')) bump();
    }, true);
    ['bkTtInput','bkSbInput','bkCdName','bkCdFrom','bkCdMsg'].forEach(function (id) {
      var el = document.getElementById(id); if (!el) return;
      var deb;
      el.addEventListener('input', function () {
        clearTimeout(deb);
        deb = setTimeout(function () { if (!counted[id] && el.value.trim()) { counted[id] = true; bump(); } }, 450);
      });
    });
    nudge.querySelector('.rsn-close').addEventListener('click', hide);
    nudge.querySelector('.rsn-later').addEventListener('click', hide);
    nudge.querySelector('.rsn-go').addEventListener('click', function () {
      hide();
      var send = document.querySelector('.bk-send');
      if (send) { window.scrollTo({ top: send.getBoundingClientRect().top + window.pageYOffset - 40, behavior: 'smooth' }); }
    });
  })();
})();